import { render, staticRenderFns } from "./AuthBase.vue?vue&type=template&id=2727b26c&scoped=true"
import script from "./AuthBase.vue?vue&type=script&lang=js"
export * from "./AuthBase.vue?vue&type=script&lang=js"
import style0 from "./AuthBase.vue?vue&type=style&index=0&id=2727b26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727b26c",
  null
  
)

export default component.exports